
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"-18 -12 36 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M-18-12h36v24h-36z"}}),_c('path',{attrs:{"d":"M0-12v24M-18 0h36","stroke":"#e8112d","stroke-width":"6","fill":"none"}}),_c('path',{attrs:{"id":"a","d":"M-9 2l1-1h9v-2h-9l-1-1z","fill":"#f9dd16"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(90)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(-90)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(180)"}})])
          )
        }
      }
    